import { Controller } from "@hotwired/stimulus"

const PROGRESS_STEPS = [
  { text: "Uploading photos...", delay: 0 },
  { text: "Reading recipe text...", delay: 3000 },
  { text: "Extracting ingredients...", delay: 8000 },
  { text: "Building directions...", delay: 15000 },
  { text: "Almost there...", delay: 25000 },
  { text: "Still working — hang tight...", delay: 40000 }
]

export default class extends Controller {
  static targets = ["button", "label", "spinner", "progress"]

  disconnect() {
    this.clearTimers()
  }

  showLoading() {
    this.buttonTarget.disabled = true
    this.labelTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
    this.spinnerTarget.classList.add("inline-flex")
    this.startProgress()
  }

  startProgress() {
    this.clearTimers()
    if (!this.hasProgressTarget) return

    this.progressTarget.classList.remove("hidden")
    this.timers = PROGRESS_STEPS.map(({ text, delay }) =>
      setTimeout(() => { this.progressTarget.textContent = text }, delay)
    )
  }

  clearTimers() {
    (this.timers || []).forEach(clearTimeout)
    this.timers = []
  }
}
